import React from 'react'
import {Container, Typography, Button, Grid} from '@mui/material'
import useStyles from './styles';

function ComeAgainPage({onContinue, header, body}) {
    const classes = useStyles();
    
    return (
        <main>
          <div className = {classes.container}>
            <Container maxWidth="sm">
                <Typography variant="h2" align="center" color="textPrimary" gutterBottom> {header}</Typography>
                <Typography variant="h6" align="center" color="textSecondary" paragraph> {body}</Typography>
               
                <Grid align = "center"><Button variant="contained" color="primary" size="large" align="right" onClick={onContinue}>OK</Button></Grid>
            </Container>
        </div>
      </main>
    )
}

export default ComeAgainPage
